<template>
  <div class="zhibo-cookie-page">
    <div class="repair_header">
      <div class="header-title">
        <div class="page-title">加热订单看板</div>
        <div class="page-meta">实时查询视频号加热订单</div>
      </div>
      <div class="toolbar-main">

        <el-popover placement="right" width="400" trigger="click">
          <el-checkbox-group v-model="colOptions">
            <el-checkbox v-for="item in colSelect" :label="item" :key="item"></el-checkbox>
          </el-checkbox-group>
          <el-button slot="reference" size="mini" v-show="!kaiguan"
                     class="toolbar-button field-setting-button">
            设置字段
          </el-button>
        </el-popover>

        <el-select
            class="account-select"
            v-model="name2"
            filterable
            size="mini"
            clearable
            default-first-option
            @change="handleAccountChange"
            placeholder="全部在线账号">
          <el-option
              v-for="item in sortedAccountOptions"
              :key="item.name"
              :label="item.name"
              :value="item.name">

            <span style="float: left">{{ item.name }}</span>

            <span v-if="item.status===0"
                  style="margin-left:5px;float: right; color: #2bd374; font-size: 13px">在线</span>
            <span v-else style="margin-left:5px;float: right; color: #8492a6; font-size: 13px">离线</span>
          </el-option>
        </el-select>

        <el-date-picker
            class="date-range-picker"
            size="mini"
            v-model="value2"
            @change="change"
            type="daterange"
            align="right"
            unlink-panels
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            :picker-options="pickerOptions"
            value-format="timestamp">
        </el-date-picker>

        <el-select v-model="stats" class="status-select" size="mini" placeholder="订单状态">
          <el-option label="全部状态" value="0"></el-option>
          <el-option label="待支付" value="1"></el-option>
          <el-option label="加热中" value="2"></el-option>
          <el-option label="已结束" value="4"></el-option>
          <el-option label="审核未过" value="6"></el-option>
        </el-select>

        <el-select
            v-model="gameFilter"
            class="game-select"
            size="mini"
            filterable
            clearable
            allow-create
            default-first-option
            placeholder="游戏"
            @change="applyOrderGameFilter">
          <el-option
              v-for="item in orderGameOptions"
              :key="item"
              :label="item"
              :value="item">
          </el-option>
        </el-select>

        <el-radio-group v-model="kaiguan" size="mini" class="view-switch">
          <el-radio-button :label="false">订单明细</el-radio-button>
          <el-radio-button :label="true">账号状态</el-radio-button>
        </el-radio-group>
        <el-button class="toolbar-button" icon="el-icon-search" size="mini" @click="search3" type="primary" v-show="searchAble">查询
        </el-button>


      </div>
      <download-excel v-show="!kaiguan" class="export-action" :data="json_data"
                      :fields="json_fields"
                      name="订单数据.xls" :fetch="createExportData">
        <el-button type="danger" size="mini">导出数据</el-button>
      </download-excel>
    </div>

    <div class="summary-grid" v-show="kaiguan">
      <div class="summary-card summary-primary">
        <span class="summary-label">账号总数</span>
        <strong>{{ accountOverview.total }}</strong>
      </div>
      <div class="summary-card summary-success">
        <span class="summary-label">在线账号</span>
        <strong>{{ accountOverview.online }}</strong>
      </div>
      <div class="summary-card summary-muted">
        <span class="summary-label">离线账号</span>
        <strong>{{ accountOverview.offline }}</strong>
      </div>
      <div class="summary-card summary-warning">
        <span class="summary-label">当前账号</span>
        <strong class="summary-account">{{ accountOverview.currentName }}</strong>
      </div>
    </div>

    <div class="summary-grid order-summary-grid" v-show="!kaiguan">
      <div class="summary-card summary-primary">
        <span class="summary-label">订单数</span>
        <strong>{{ orderOverview.total }}</strong>
      </div>
      <div class="summary-card summary-info">
        <span class="summary-label">订单预算</span>
        <strong>{{ orderOverview.budget }}</strong>
      </div>
      <div class="summary-card summary-danger">
        <span class="summary-label">订单消耗</span>
        <strong>{{ orderOverview.cost }}</strong>
      </div>
      <div class="summary-card summary-progress">
        <span class="summary-label">消耗进度</span>
        <strong>{{ orderOverview.progressText }}</strong>
        <el-progress :percentage="orderOverview.displayProgress" :show-text="false"></el-progress>
      </div>
      <div class="summary-card summary-success">
        <span class="summary-label">付费金额</span>
        <strong>{{ orderOverview.payAmount }}</strong>
      </div>
      <div class="summary-card summary-purple">
        <span class="summary-label">广告变现</span>
        <strong>{{ orderOverview.adIncome }}</strong>
      </div>
    </div>

    <div class="repairOrder_div" v-show="kaiguan">
      <div class="table-card">
        <div class="table-card-head">
          <div>
            <div class="card-title">账号列表</div>
            <div class="card-meta">当前：{{ accountOverview.currentName }}</div>
          </div>
          <el-tag size="mini" type="success" effect="plain">{{ accountOverview.online }} 在线</el-tag>
        </div>
        <!--        数据表-->
        <el-table
            :data="tableData"
            border
            :header-cell-style="{background:'#f8f8f9',textAlign:'center',color:'#515A6E','padding':'15px'}"
            class="table-1"
            height="calc(100vh - 306px)"
            size="mini"
            ref="cookieTable"
            highlight-current-row
            empty-text="暂无账号数据"
            :row-class-name="cookieRowClassName"
            v-loading="loading"

        >


          <el-table-column
              align="center"
              prop="name"
              label="账号名称"
              min-width="160"
          >

          </el-table-column>


          <el-table-column
              align="center"
              prop="cookie"
              label="Cookie"
              min-width="260"
              show-overflow-tooltip
          >
            <template slot-scope="scope">
              <span class="cookie-preview">{{ cookiePreview(scope.row.cookie) }}</span>
            </template>

          </el-table-column>


          <el-table-column
              align="center"
              prop="status"
              label="状态"

          >


            <template slot-scope="scope">

              <el-tag
                  v-if="scope.row.status==0"
                  type="success"
                  size="mini"
                  effect="plain">
                在线
              </el-tag>
              <el-tag
                  v-else
                  type="info"
                  size="mini"
                  effect="plain">
                离线
              </el-tag>

            </template>
          </el-table-column>

          <!--                    <el-table-column-->
          <!--                            align="center"-->
          <!--                            prop="dataReady"-->
          <!--                            label="昨日数据"-->

          <!--                    >-->

          <!--                    </el-table-column>-->

          <el-table-column
              align="center"
              prop="state"
              label="当前账号"
              min-width="110"
          >
            <template slot-scope="scope">
              <el-tag :type="scope.row.state == 0 ? 'warning' : 'info'" size="mini" effect="plain">
                {{ formatter(scope.row) }}
              </el-tag>
            </template>

          </el-table-column>
          <el-table-column
              prop="cDate"
              label="复制"
              align="center"
              width="100"

          >

            <template slot-scope="scope">

              <div>
                <el-button class="table-action" size="mini" type="text" icon="el-icon-document-copy" @click.stop="celldblclick(scope.row)">复制</el-button>

              </div>


            </template>


          </el-table-column>

          <el-table-column
              prop="cDate"
              label="刷新"
              align="center"
              width="100"

          >

            <template slot-scope="scope">

              <div>
                <el-button class="table-action" size="mini" type="text" icon="el-icon-refresh" @click.stop="search2(scope.row)">刷新</el-button>

              </div>


            </template>


          </el-table-column>
        </el-table>

      </div>

    </div>


    <div class="repairOrder_div" v-show="!kaiguan">
      <div class="table-card">
        <div class="table-card-head">
          <div>
            <div class="card-title">订单明细</div>
            <div class="card-meta">
              共 {{ tableData2.length }} 条
              <span v-if="gameFilter">，游戏：{{ gameFilter }}</span>
              <span v-if="!name2 && accountNames.length">，账号范围：{{ accountNames.length }} 个</span>
            </div>
          </div>
          <el-tag size="mini" type="warning" effect="plain">{{ orderOverview.cost }} 消耗</el-tag>
        </div>


        <!--        数据表-->
        <el-table
            :data="tableData2"
            border
            :header-cell-style="{background:'#f8f8f9',textAlign:'center',color:'#515A6E','padding':'2px'}"
            :row-style="{ height: '35px' }"
            size="mini"
            stripe
            ref="orderTable"
            highlight-current-row

            height="calc(100vh - 342px)"
            v-loading="loading2"
            empty-text="暂无订单数据"
            :summary-method="getSummaries"
            show-summary
        >
          <el-table-column
              type="index"

              align="center"
              width="60">
          </el-table-column>

          <el-table-column
              align="center"
              prop="orderInfo.createTs"
              label="订单日期"
              :formatter="format"
              min-width="140"
          >

          </el-table-column>


          <el-table-column
              align="center"
              prop="orderInfo.promotionId"
              label="订单号"
              min-width="160"
          >
            <template slot-scope="scope">


              <div style="font-weight: bolder">{{ scope.row.orderInfo.promotionId }}</div>

            </template>
          </el-table-column>

          <el-table-column
              align="center"
              prop="orderInfo.status"
              label="状态"
              min-width="96"

              show-overflow-tooltip
          >
            <template slot-scope="scope">
              <el-tag size="mini" :type="orderStatusType(scope.row.orderInfo.status)" effect="plain">
                {{ orderStatusText(scope.row.orderInfo.status) }}
              </el-tag>
            </template>
          </el-table-column>
          <el-table-column
              align="center"
              prop="finderObject.finderComponent.wording"
              label="游戏"
              min-width="140"
          >
          </el-table-column>

          <el-table-column
              align="center"
              prop="orderInfo.targetUserInfo.headImgUrl"
              label="封面"
              width="88"
              style="height: 66px;"
          >
            <template slot-scope="scope">

              <el-image class="cover-image" :src="scope.row.finderObject.coverUrl" fit="cover"></el-image>
            </template>

          </el-table-column>
          <el-table-column
              prop="orderInfo.targetUserInfo.nickName"
              label="名称"
              align="center"
              min-width="140"
          >

          </el-table-column>
          <el-table-column
              prop="orderInfo.estimatedWecoinAmount"
              label="订单预算"
              align="center"
              min-width="140"

          >
            <template slot-scope="scope">


              <div style="color: #0b77e3">{{ scope.row.orderInfo.estimatedWecoinAmount / 10 }}</div>

            </template>
          </el-table-column>
          <el-table-column
              prop="indicator.cost"
              label="订单消耗"
              sortable
              min-width="140"
              align="center"

          >
            <template slot-scope="scope">


              <div style="color: red">{{ scope.row.orderInfo.cost / 100 }}</div>

            </template>

          </el-table-column>
          <el-table-column
              prop="orderInfo.cost"
              label="消耗进度"
              align="center"
              min-width="140"
          >
            <template slot-scope="scope">

              <el-progress style="color: #00cd00"
                           :percentage="(scope.row.orderInfo.cost/10/scope.row.orderInfo.estimatedWecoinAmount*100).toFixed(1)"></el-progress>

            </template>

          </el-table-column>

          <el-table-column
              prop="orderInfo.paymentInfo.indemnifyVoucherAmountInCents"
              label="补贴券"
              align="center"
              min-width="140"
          >
            <template slot-scope="scope">

              <div>{{ scope.row.orderInfo.paymentInfo.indemnifyVoucherAmountInCents / 1000 }}</div>
            </template>
          </el-table-column>
          <el-table-column label="付费内容" v-if="colData[0].istrue">
            <el-table-column
                prop="orderInfo.suggest.roiBidX100"
                label="付费ROI出价"
                align="center"
                min-width="140"
                v-if="colData[0].istrue"

            >


            </el-table-column>

            <el-table-column
                prop="dataAttributionCycle"
                label="数据归因周期"
                align="center"
                min-width="140"
                v-if="colData[0].istrue"

            >
              <template slot-scope="scope">
                <el-tag v-if="formatAttributionCycle(scope.row)" size="mini" type="info" effect="plain">
                  {{ formatAttributionCycle(scope.row) }}
                </el-tag>
                <span v-else>-</span>
              </template>

            </el-table-column>

            <el-table-column
                prop="orderInfo.suggest.roiBidX100"
                label="付费出价"
                align="center"
                min-width="140"
                v-if="colData[0].istrue"
            >
              <template>0</template>

            </el-table-column>

            <el-table-column
                prop="indicator.feedGamePropspayPrice"
              label="付费金额"
                align="center"
                min-width="140"
                :formatter="value_format"
                v-if="colData[0].istrue"
            >

              <template slot-scope="scope">
                <div v-if="scope.row.indicator.feedGamePropspayPrice >0" style="background-color: #9370DB;color: #f4f4f5">
                  {{ scope.row.indicator.feedGamePropspayPrice  }}
                </div>
                <div v-else>
                  {{ scope.row.indicator.feedGamePropspayPrice  }}
                </div>
              </template>

            </el-table-column>


          </el-table-column>

          <el-table-column label="广告内容" v-if="colData[1].istrue">
            <el-table-column
                prop="orderInfo.suggest.roiBidX100"
                label="广告变现成本"
                align="center"
                min-width="140"

            >

              <template slot-scope="scope">
                {{ formatMetricNumber(getOrderAdCost(scope.row), 2) }}
              </template>

            </el-table-column>
            <el-table-column
                prop="indicator.feedMinigameAdsexposeUv"
                label="广告变现人数"
                align="center"
                min-width="140"

            >

              <template slot-scope="scope">
                {{ formatMetricNumber(getOrderAdUsers(scope.row), 0) }}
              </template>
            </el-table-column>

            <el-table-column
                prop="orderInfo.estimatedExposure"
                label="预估广告变现人数"
                align="center"
                min-width="150"

            >

            </el-table-column>

          </el-table-column>
          <el-table-column
              prop="orderInfo.suggest.roiBidX100"
              label="点击成本"
              align="center"
              min-width="140"

          >
            <template slot-scope="scope">
              {{ formatMetricNumber(getOrderClickCost(scope.row), 2) }}
            </template>

          </el-table-column>
          <el-table-column
              prop="indicator.exposureCount"
              label="浏览量"
              align="center"
              min-width="140"

          >

          </el-table-column>

          <el-table-column
              prop="indicator.feedGamePropspayUv"
              label="付费人数"
              align="center"
              min-width="140"
              v-if="colData[0].istrue"
          >


          </el-table-column>
          <el-table-column
              label="首日IPU"
              align="center"
              min-width="100"
          >
            <template slot-scope="scope">
              {{ formatMetricNumber(getOrderFirstDayIpu(scope.row), 2) }}
            </template>
          </el-table-column>
          <el-table-column
              label="24h IPU"
              align="center"
              min-width="100"
          >
            <template slot-scope="scope">
              {{ formatMetricNumber(getOrder24hIpu(scope.row), 2) }}
            </template>
          </el-table-column>
          <el-table-column
              label="cpm"
              align="center"
              min-width="100"
          >
            <template slot-scope="scope">
              {{ formatMetricNumber(getOrderCpm(scope.row), 2) }}
            </template>
          </el-table-column>
          <el-table-column
              prop="indicator.feedGameAdspayPrice"
              label="广告变现金额"
              align="center"
              min-width="140"

          >
            <template slot-scope="sco">

              {{ formatMetricNumber(getOrderAdAmount(sco.row), 2) }}
            </template>

          </el-table-column>
          <el-table-column
              prop="indicator.feedGameAdspayPrice"
              label="广告变现ROI"
              align="center"
              min-width="140"

          >

            <template slot-scope="sco">

              {{ formatAdRoi(sco.row) }}
            </template>


          </el-table-column>

        </el-table>
        <el-pagination

            layout="total"
            :total="tableData2.length">
        </el-pagination>
      </div>

    </div>
  </div>


</template>

<script>
const ZHIBO_COOKIE_VIEW_KEY = 'zhiboDataCookie.kaiguan'

function defaultDateRange() {
  const today = new Date()
  today.setHours(0, 0, 0, 0)
  const timestamp = today.getTime()
  return [timestamp, timestamp]
}

export default {
  name: "VideoBoostOrders",
  data() {
    return {
      loading: false,
      form: {
        cookies: "",
        name: ""

      },
      options_status: [
        {
          "label": "已处理",
          "value": 0,


        }, {

          "label": "待处理",
          "value": 1,

        }


      ], status: 1,
      price: 20,
      name2: '',
      kaiguan: this.getSavedKaiguan(),
      pickerOptions: {
        shortcuts: [{
          text: '最近一周',
          onClick(picker) {
            const end = new Date();
            const start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
            picker.$emit('pick', [start, end]);
          }
        }, {
          text: '最近一个月',
          onClick(picker) {
            const end = new Date();
            const start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
            picker.$emit('pick', [start, end]);
          }
        }, {
          text: '最近三个月',
          onClick(picker) {
            const end = new Date();
            const start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
            picker.$emit('pick', [start, end]);
          }
        }]
      },
      colData: [{title: "付费", istrue: true},
        {title: "广告", istrue: true},
      ],
      colOptions: ["付费", "广告"], //默认全选
      colSelect: ["付费", "广告"],
      value_contain: '',
      value_reply: '',
      value: '',
      options: [],
      value_openid: '',
      options_type: [{"label": "充值问题", "value": 1}, {"label": "BUG反馈", "value": 3}, {
        "label": "游戏建议",
        "value": 4
      }, {"label": "其他问题", "value": 5}, {"label": "账号问题", "value": 2}],
      value_type: '',
      size: 0,
      searchAble: true,
      textarea: '',
      currentPage: 1,
      srcList: [],
      url: '',
      value2: defaultDateRange(),
      options_reply: ['1', '2', '3'],
      centerDialogVisible: false,
      multipleSelection: [],
      dialogFormVisible: false,
      tableData: this.$route.params.id == null ? [] : this.$route.params.id,

      tableData2: [],
      allOrderRows: [],
      gameFilter: '',
      accountNames: [],
      loading2: false,
      stats: '0',
      json_data: [],
      json_fields: {
        '订单号': 'orderInfo.promotionId',
        '补贴券': 'orderInfo.paymentInfo.indemnifyVoucherAmountInCents',
        '游戏': 'finderObject.finderComponent.wording',
        '封面': 'orderInfo.targetUserInfo.headImgUrl',
        '名称': 'orderInfo.targetUserInfo.nickName',
        '订单消耗': 'orderInfo.cost',
        '订单预算': 'orderInfo.estimatedWecoinAmount',
        '订单日期': 'date',
        '付费ROI出价': 'orderInfo.suggest.roiBidX100',
        '数据归因周期': 'dataAttributionCycle',
        '付费出价': '0',
        '付费金额': 'indicator.feedGamePropspayPrice',
        '付费人数': 'indicator.feedGamePropspayUv',
        '点击成本': 'exportMetrics.clickCost',
        '浏览量': 'indicator.exposureCount',
        '首日IPU': 'exportMetrics.firstDayIpu',
        '24h IPU': 'exportMetrics.ipu24h',
        'cpm': 'exportMetrics.cpm',
        '广告变现金额': 'exportMetrics.adAmount',
        '广告变现ROI': 'exportMetrics.adRoi'
      },
      // loading:true
    }
  },
  mounted: function () {
    const shouldSearchOrders = this.applyRouteFilters() || this.hasOrderRouteQuery()
    this.search()
    if (shouldSearchOrders) {
      this.search3()
    }
  }, destroyed() {
    //取消键盘监听事件
    document.onkeydown = null
  }, computed: {
    sortedAccountOptions() {
      const rows = Array.isArray(this.tableData) ? this.tableData : []
      return rows.slice().sort((a, b) => {
        const statusA = a.status === 0 ? 0 : 1
        const statusB = b.status === 0 ? 0 : 1
        if (statusA !== statusB) {
          return statusA - statusB
        }
        return String(a.name || '').localeCompare(String(b.name || ''), 'zh-Hans-CN')
      })
    },
    accountOverview() {
      const rows = Array.isArray(this.tableData) ? this.tableData : []
      const online = rows.filter(item => item.status === 0).length
      const current = rows.find(item => item.state === 0)
      return {
        total: rows.length,
        online: online,
        offline: rows.length - online,
        currentName: current && current.name ? current.name : '-'
      }
    },
    orderGameOptions() {
      const rows = this.allOrderRows.length ? this.allOrderRows : this.tableData2
      const names = new Set()
      ;(Array.isArray(rows) ? rows : []).forEach(row => {
        const name = this.getOrderGameName(row)
        if (name) {
          names.add(name)
        }
      })
      return Array.from(names).sort((a, b) => String(a).localeCompare(String(b), 'zh-Hans-CN'))
    },
    orderOverview() {
      const rows = Array.isArray(this.tableData2) ? this.tableData2 : []
      let budget = 0
      let cost = 0
      let payAmount = 0
      let adIncome = 0

      rows.forEach(row => {
        budget += this.toNumber(this.getValue(row, 'orderInfo.estimatedWecoinAmount')) / 10
        cost += this.toNumber(this.getValue(row, 'orderInfo.cost')) / 100
        payAmount += this.toNumber(this.getValue(row, 'indicator.feedGamePropspayPrice'))
        adIncome += this.toNumber(this.getOrderAdAmount(row))
      })

      const progress = budget > 0 ? (cost / budget * 100) : 0
      return {
        total: rows.length,
        budget: this.formatSummary(budget, 1),
        cost: this.formatSummary(cost, 1),
        payAmount: this.formatSummary(payAmount, 1),
        adIncome: this.formatSummary(adIncome, 1),
        progressText: this.formatSummary(progress, 1) + '%',
        displayProgress: Math.min(100, Math.max(0, Number(progress.toFixed(1))))
      }
    }
  }, watch: {

    kaiguan(val) {
      this.saveKaiguan(val)
      this.doTableLayout()
    },
    colOptions(valArr) {
      var arr = this.colSelect.filter(i => valArr.indexOf(i) < 0); // 未选中
      this.colData.forEach(i => {
        i.istrue = arr.indexOf(i.title) === -1;
      });
      this.doTableLayout();
    },
    '$route.query'() {
      if (this.applyRouteFilters() || this.hasOrderRouteQuery()) {
        this.search3()
      }
    }
  }, updated() {

    this.doTableLayout()
  },
  methods: {
    getSavedKaiguan() {
      try {
        const value = window.localStorage.getItem(ZHIBO_COOKIE_VIEW_KEY)
        return value === null ? false : value === 'true'
      } catch (e) {
        return false
      }
    },
    saveKaiguan(value) {
      try {
        window.localStorage.setItem(ZHIBO_COOKIE_VIEW_KEY, value ? 'true' : 'false')
      } catch (e) {
        console.log('保存开关状态失败', e)
      }
    },
    getValue(obj, path) {
      return path.split('.').reduce((result, key) => {
        if (result && result[key] !== undefined && result[key] !== null) {
          return result[key]
        }
        return null
      }, obj)
    },
    cleanRouteValue(value) {
      const text = String(value == null ? '' : value).trim()
      return text === '-' ? '' : text
    },
    hasOrderRouteQuery() {
      const query = (this.$route && this.$route.query) || {}
      return !!(query.jump || query.game != null || query.account != null || query.accounts != null || query.id != null || query.start != null || query.end != null || query.status != null)
    },
    applyRouteFilters() {
      const query = (this.$route && this.$route.query) || {}
      if (!query || Object.keys(query).length === 0) {
        return false
      }
      let changed = false
      const setIfChanged = (key, value) => {
        if (this[key] !== value) {
          this[key] = value
          changed = true
        }
      }

      if (query.start != null && query.end != null) {
        const start = Number(query.start)
        const end = Number(query.end)
        if (Number.isFinite(start) && Number.isFinite(end) && start > 0 && end > 0) {
          const nextRange = [start, end]
          if (!Array.isArray(this.value2) || this.value2[0] !== nextRange[0] || this.value2[1] !== nextRange[1]) {
            this.value2 = nextRange
            changed = true
          }
        }
      }
      if (query.status != null) {
        setIfChanged('stats', String(query.status))
      }
      if (query.account != null || query.id != null) {
        setIfChanged('name2', this.cleanRouteValue(query.account != null ? query.account : query.id))
      } else if (query.accounts != null) {
        setIfChanged('name2', '')
      }
      if (query.accounts != null) {
        const nextAccounts = this.parseRouteList(query.accounts)
        if (!this.routeListEquals(this.accountNames, nextAccounts)) {
          this.accountNames = nextAccounts
          changed = true
        }
      } else if (this.accountNames.length) {
        this.accountNames = []
        changed = true
      }
      if (query.game != null) {
        setIfChanged('gameFilter', this.cleanRouteValue(query.game))
      }
      if (query.jump === 'order-game' || query.game != null) {
        if (this.kaiguan !== false) {
          this.kaiguan = false
          changed = true
        }
      }
      return changed
    },
    parseRouteList(value) {
      return String(value == null ? '' : value)
          .split(/[、,，;；\r\n]+/)
          .map(item => item.trim())
          .filter(item => item && item !== '-')
    },
    routeListEquals(left, right) {
      if (!Array.isArray(left) || !Array.isArray(right) || left.length !== right.length) {
        return false
      }
      for (let index = 0; index < left.length; index++) {
        if (left[index] !== right[index]) {
          return false
        }
      }
      return true
    },
    handleAccountChange() {
      this.accountNames = []
    },
    getOrderGameName(row) {
      return this.getValue(row, 'finderObject.finderComponent.wording')
          || this.getValue(row, 'finderObject.finderComponent.gameName')
          || this.getValue(row, 'finderObject.gameName')
          || this.getValue(row, 'orderInfo.gameName')
          || (row && row.gameName)
          || ''
    },
    applyOrderGameFilter() {
      const rows = this.allOrderRows.length ? this.allOrderRows : this.tableData2
      const game = this.cleanRouteValue(this.gameFilter)
      if (!game) {
        this.tableData2 = rows.slice()
      } else {
        this.tableData2 = rows.filter(row => this.getOrderGameName(row) === game)
      }
      this.doTableLayout()
    },
    toNumber(value) {
      const number = parseFloat(value)
      return isNaN(number) ? 0 : number
    },
    formatSummary(value, fraction) {
      const fixed = this.toNumber(value).toFixed(fraction || 0)
      const parts = fixed.split('.')
      parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',')
      return parts.join('.')
    },
    cookiePreview(cookie) {
      if (!cookie) {
        return '-'
      }
      const value = String(cookie)
      if (value.length <= 36) {
        return value
      }
      return value.slice(0, 18) + ' ... ' + value.slice(-10)
    },
    cookieRowClassName({row}) {
      if (row.state === 0) {
        return 'is-current-cookie'
      }
      if (row.status === 0) {
        return 'is-online-cookie'
      }
      return ''
    },
    orderStatusText(status) {
      switch (Number(status)) {
        case 1:
          return '待支付'
        case 2:
          return '加热中'
        case 4:
          return '已结束'
        case 6:
          return '审核未过'
        default:
          return '已完成'
      }
    },
    orderStatusType(status) {
      switch (Number(status)) {
        case 1:
          return 'warning'
        case 2:
          return 'success'
        case 4:
          return 'info'
        case 6:
          return 'danger'
        default:
          return ''
      }
    },
    formatAttributionCycle(row) {
      const value = this.getValue(row, 'dataAttributionCycle') || this.getValue(row, 'orderInfo.dataAttributionCycle')
      if (value) {
        return value
      }

      const promotionTarget = this.toNumber(this.getValue(row, 'orderInfo.promotionTarget') || this.getValue(row, 'promotionTarget'))
      if (promotionTarget === 27) {
        return '首日'
      }
      if (promotionTarget === 28) {
        return '7日'
      }

      return ''
    },
    hasDisplayValue(value) {
      return value !== undefined && value !== null && value !== '' && value !== '-'
    },
    numberValue(value) {
      if (!this.hasDisplayValue(value)) {
        return null
      }
      const number = parseFloat(String(value).replace(/,/g, ''))
      return Number.isFinite(number) ? number : null
    },
    firstOrderValue(row, paths) {
      for (let index = 0; index < paths.length; index++) {
        const value = this.getValue(row, paths[index])
        if (this.hasDisplayValue(value)) {
          return value
        }
      }
      return null
    },
    scaledOrderValue(row, paths, scale) {
      const value = this.firstOrderValue(row, paths)
      const number = this.numberValue(value)
      return number === null ? null : number / scale
    },
    formatMetricNumber(value, fraction) {
      const number = this.numberValue(value)
      if (number === null) {
        return '-'
      }
      return this.formatSummary(number, fraction)
    },
    getOrderSpend(row) {
      return this.scaledOrderValue(row, [
        'orderInfo.cost',
        'indicator.orderCost',
        'indicator.cost'
      ], 100)
    },
    getOrderAdAmount(row) {
      return this.scaledOrderValue(row, [
        'indicator.feedGameAdspayPrice',
        'indicator.feedGameAdsPayPrice',
        'indicator.feedGameAdPayPrice',
        'indicator.adMonetizationAmount',
        'indicator.adMonetizationPrice',
        'orderInfo.adMonetizationAmount'
      ], 100)
    },
    getOrderAdRoi(row) {
      const value = this.firstOrderValue(row, [
        'indicator.feedGameAdspayRoi',
        'indicator.feedGameAdsPayRoi',
        'indicator.feedGameAdRoi',
        'indicator.adMonetizationRoi',
        'indicator.adRoi',
        'orderInfo.adMonetizationRoi'
      ])
      if (this.hasDisplayValue(value)) {
        return value
      }
      const spend = this.numberValue(this.getOrderSpend(row))
      const adAmount = this.numberValue(this.getOrderAdAmount(row))
      if (!spend || adAmount === null) {
        return null
      }
      return adAmount / spend
    },
    formatAdRoi(row) {
      return this.formatMetricNumber(this.getOrderAdRoi(row), 2)
    },
    getOrderAdUsers(row) {
      return this.firstOrderValue(row, [
        'indicator.feedMinigameAdsexposeUv',
        'indicator.feedMinigameAdsExposeUv',
        'indicator.feedGameAdspayUv',
        'indicator.feedGameAdsPayUv',
        'indicator.adMonetizationUv',
        'indicator.adUsers'
      ])
    },
    getOrderAdMonetizationCount(row) {
      return this.firstOrderValue(row, [
        'indicator.feedMinigameAdsexposePv',
        'indicator.feedMinigameAdsExposePv',
        'indicator.feedGameAdspayPv',
        'indicator.feedGameAdsPayPv',
        'indicator.feedGameAdspayCnt',
        'indicator.feedGameAdsPayCnt',
        'indicator.feedGameAdspayCount',
        'indicator.feedGameAdsPayCount',
        'indicator.adMonetizationPv',
        'indicator.adMonetizationCount',
        'indicator.adMonetizationCnt',
        'indicator.miniGameAdMonetizationPv',
        'indicator.miniGameAdMonetizationCount'
      ])
    },
    getOrderFirstDayAdUsers(row) {
      const value = this.firstOrderValue(row, [
        'indicator.firstDayFeedMinigameAdsexposeUv',
        'indicator.firstDayFeedMinigameAdsExposeUv',
        'indicator.firstDayFeedGameAdspayUv',
        'indicator.firstDayFeedGameAdsPayUv',
        'indicator.firstDayAdMonetizationUv',
        'indicator.feedMinigameAdsexposeUv1d',
        'indicator.feedMinigameAdsExposeUv1d',
        'indicator.feedMinigameAdsexposeUvD1',
        'indicator.feedMinigameAdsExposeUvD1',
        'indicator.adMonetizationUv1d',
        'indicator.adMonetizationUvD1'
      ])
      if (this.hasDisplayValue(value)) {
        return value
      }
      return this.isFirstDayOrder(row) ? this.getOrderAdUsers(row) : null
    },
    getOrderFirstDayAdMonetizationCount(row) {
      const value = this.firstOrderValue(row, [
        'indicator.firstDayFeedMinigameAdsexposePv',
        'indicator.firstDayFeedMinigameAdsExposePv',
        'indicator.firstDayFeedGameAdspayPv',
        'indicator.firstDayFeedGameAdsPayPv',
        'indicator.firstDayAdMonetizationPv',
        'indicator.firstDayAdMonetizationCount',
        'indicator.feedMinigameAdsexposePv1d',
        'indicator.feedMinigameAdsExposePv1d',
        'indicator.feedMinigameAdsexposePvD1',
        'indicator.feedMinigameAdsExposePvD1',
        'indicator.adMonetizationPv1d',
        'indicator.adMonetizationCount1d',
        'indicator.adMonetizationPvD1',
        'indicator.adMonetizationCountD1'
      ])
      if (this.hasDisplayValue(value)) {
        return value
      }
      return this.isFirstDayOrder(row) ? this.getOrderAdMonetizationCount(row) : null
    },
    isFirstDayOrder(row) {
      const cycle = String(this.formatAttributionCycle(row) || '')
      const target = this.toNumber(this.getValue(row, 'orderInfo.promotionTarget') || this.getValue(row, 'promotionTarget'))
      return cycle.indexOf('首') !== -1 || target === 27
    },
    getOrderFirstDayIpu(row) {
      const count = this.numberValue(this.getOrderFirstDayAdMonetizationCount(row))
      const users = this.numberValue(this.getOrderFirstDayAdUsers(row))
      if (count === null || !users) {
        return null
      }
      return count / users
    },
    getOrder24hIpu(row) {
      const count = this.numberValue(this.getOrderAdMonetizationCount(row))
      const users = this.numberValue(this.getOrderAdUsers(row))
      if (count === null || !users) {
        return null
      }
      return count / users
    },
    getOrderCpm(row) {
      const value = this.firstOrderValue(row, [
        'indicator.averageEcpm',
        'indicator.avgEcpm',
        'indicator.ecpm',
        'indicator.cpm',
        'indicator.feedCpm',
        'indicator.feedGameCpm'
      ])
      if (this.hasDisplayValue(value)) {
        return value
      }
      const adAmount = this.numberValue(this.getOrderAdAmount(row))
      const count = this.numberValue(this.getOrderAdMonetizationCount(row))
      if (adAmount === null || !count) {
        return null
      }
      return adAmount / count * 1000
    },
    getOrderAdCost(row) {
      const spend = this.numberValue(this.getOrderSpend(row))
      const users = this.numberValue(this.getOrderAdUsers(row))
      if (spend === null || !users) {
        return null
      }
      return spend / users
    },
    getOrderClickCost(row) {
      const spend = this.numberValue(this.getOrderSpend(row))
      const clickUv = this.numberValue(this.getValue(row, 'indicator.feedComponentClickUv'))
      if (spend === null || !clickUv) {
        return null
      }
      return spend / clickUv
    },
    buildExportRow(row) {
      return Object.assign({}, row, {
        exportMetrics: {
          clickCost: this.formatMetricNumber(this.getOrderClickCost(row), 2),
          firstDayIpu: this.formatMetricNumber(this.getOrderFirstDayIpu(row), 2),
          ipu24h: this.formatMetricNumber(this.getOrder24hIpu(row), 2),
          cpm: this.formatMetricNumber(this.getOrderCpm(row), 2),
          adAmount: this.formatMetricNumber(this.getOrderAdAmount(row), 2),
          adRoi: this.formatAdRoi(row)
        }
      })
    },
    normalizeOrderRows(rows) {
      if (!Array.isArray(rows)) {
        return []
      }
      rows.forEach(row => {
        row.dataAttributionCycle = this.formatAttributionCycle(row)
        if (row.orderInfo) {
          row.orderInfo.dataAttributionCycle = row.dataAttributionCycle
        }
        if (row.orderInfo && row.orderInfo.suggest) {
          row.orderInfo.suggest.roiBidX100 = row.orderInfo.suggest.roiBidX100 == null ? 0 : parseFloat(row.orderInfo.suggest.roiBidX100 / 100)
        }
        if (row.indicator) {
          row.indicator.feedGamePropspayPrice = row.indicator.feedGamePropspayPrice == null ? 0 : parseFloat(row.indicator.feedGamePropspayPrice / 100)
        }
      })
      return rows
    },
    change() {
      this.doTableLayout()
    },
    doTableLayout() {
      this.$nextTick(() => {
        const tables = [this.$refs.cookieTable, this.$refs.orderTable]
        tables.forEach(table => {
          if (Array.isArray(table)) {
            table.forEach(item => {
              if (item && item.doLayout) {
                item.doLayout()
              }
            })
          } else if (table && table.doLayout) {
            table.doLayout()
          }
        })
      })
    },

    getSummaries(param) {
      const {columns, data} = param;
      const sums = [];

      const rows = Array.isArray(data) ? data : []
      const total = {
        orders: rows.length,
        budget: 0,
        cost: 0,
        subsidy: 0,
        roiBid: 0,
        roiBidCount: 0,
        payAmount: 0,
        payPeople: 0,
        adPeople: 0,
        adTimes: 0,
        firstAdPeople: 0,
        firstAdTimes: 0,
        adEstimate: 0,
        clickUv: 0,
        exposure: 0,
        adIncome: 0
      }

      rows.forEach(row => {
        total.budget += this.toNumber(this.getValue(row, 'orderInfo.estimatedWecoinAmount')) / 10
        total.cost += this.toNumber(this.getValue(row, 'orderInfo.cost')) / 100
        total.subsidy += this.toNumber(this.getValue(row, 'orderInfo.paymentInfo.indemnifyVoucherAmountInCents')) / 1000
        const roiBid = this.toNumber(this.getValue(row, 'orderInfo.suggest.roiBidX100'))
        if (roiBid > 0) {
          total.roiBid += roiBid
          total.roiBidCount++
        }
        total.payAmount += this.toNumber(this.getValue(row, 'indicator.feedGamePropspayPrice'))
        total.payPeople += this.toNumber(this.getValue(row, 'indicator.feedGamePropspayUv'))
        total.adPeople += this.toNumber(this.getOrderAdUsers(row))
        total.adTimes += this.toNumber(this.getOrderAdMonetizationCount(row))
        total.firstAdPeople += this.toNumber(this.getOrderFirstDayAdUsers(row))
        total.firstAdTimes += this.toNumber(this.getOrderFirstDayAdMonetizationCount(row))
        total.adEstimate += this.toNumber(this.getValue(row, 'orderInfo.estimatedExposure'))
        total.clickUv += this.toNumber(this.getValue(row, 'indicator.feedComponentClickUv'))
        total.exposure += this.toNumber(this.getValue(row, 'indicator.exposureCount'))
        total.adIncome += this.toNumber(this.getOrderAdAmount(row))
      })

      const divide = (value, divisor, fraction) => {
        if (!divisor) {
          return '-'
        }
        return (value / divisor).toFixed(fraction)
      }

      columns.forEach((column, index) => {
        switch (column.label) {
          case '订单预算':
            sums[index] = this.formatSummary(total.budget, 2)
            break
          case '订单消耗':
            sums[index] = this.formatSummary(total.cost, 2)
            break
          case '消耗进度':
            sums[index] = total.budget ? (total.cost / total.budget * 100).toFixed(2) + '%' : '-'
            break
          case '补贴券':
            sums[index] = this.formatSummary(total.subsidy, 2)
            break
          case '付费ROI出价':
            sums[index] = total.roiBidCount ? '均值 ' + this.formatSummary(total.roiBid / total.roiBidCount, 2) : '-'
            break
          case '付费出价':
            sums[index] = '0.00'
            break
          case '付费金额':
            sums[index] = this.formatSummary(total.payAmount, 2)
            break
          case '付费人数':
            sums[index] = this.formatSummary(total.payPeople, 0)
            break
          case '广告变现成本':
            sums[index] = divide(total.cost, total.adPeople, 2)
            break
          case '广告变现人数':
            sums[index] = this.formatSummary(total.adPeople, 0)
            break
          case '预估广告变现人数':
            sums[index] = this.formatSummary(total.adEstimate, 0)
            break
          case '点击成本':
            sums[index] = divide(total.cost, total.clickUv, 2)
            break
          case '浏览量':
            sums[index] = this.formatSummary(total.exposure, 0)
            break
          case '首日IPU':
            sums[index] = divide(total.firstAdTimes, total.firstAdPeople, 2)
            break
          case '24h IPU':
            sums[index] = divide(total.adTimes, total.adPeople, 2)
            break
          case 'cpm':
            sums[index] = total.adTimes ? this.formatSummary(total.adIncome / total.adTimes * 1000, 2) : '-'
            break
          case '广告变现金额':
            sums[index] = this.formatSummary(total.adIncome, 2)
            break
          case '广告变现ROI':
            sums[index] = divide(total.adIncome, total.cost, 2)
            break
          case '订单号':
            sums[index] = this.formatSummary(total.orders, 0) + ' 单'
            break
          default:
            sums[index] = index === 0 ? '总计' : ''
        }
      })

      return sums;
    },
    formatter(row) {

      return row.state == 0 ? '当前登录' : '未选择';
    }, celldblclick(row) {


      var save = function (e) {
        e.clipboardData.setData('text/plain', row['cookie']);
        e.preventDefault();//阻止默认行为
      }
      document.addEventListener('copy', save);
      document.execCommand("copy");
      document.removeEventListener('copy', save);

      this.$message({message: '复制成功', type: 'success'}) //复制成功后提示

    },
    click(row) {


      this.$axios
          .get('/data/zhibo/updateState?name=' + row.name, {})
          .then(successResponse => {
            if (successResponse.status == 200) {

              this.search(1)

              // console.log(successResponse.data.advertDataList)
            } else {
              this.$router.replace({path: '/error'})
              console.log("错误")

            }
          })
    }, format(row, column, cellValue) {

      const date = new Date(cellValue * 1000);

      const year = date.getFullYear();
      const month = date.getMonth() + 1;
      const day = date.getDate();
      const hours = date.getHours();
      const minutes = date.getMinutes();
      const seconds = date.getSeconds();

      return year + "-" + month + "-" + day + " " + hours + ":" + minutes + ":" + seconds


    },

    format_status(a, b, c) {


      return c == 0 ? '已登录' : '未登录'
    },
    createExportData() {

      this.json_data = this.tableData2.map(row => this.buildExportRow(row))

      return this.json_data
    },

    async search() {
      this.loading = true
      try {
        const response = await this.$axios.post('/data/zhibo/findAllCookies', {})
        if (!response.data || !response.data.success) {
          throw new Error((response.data && response.data.msg) || '账号查询失败')
        }
        this.tableData = Array.isArray(response.data.data) ? response.data.data : []
        this.size = this.tableData.length
      } catch (error) {
        this.tableData = []
        this.$message.error(error.message || '账号查询失败')
      } finally {
        this.loading = false
      }
    },
    search2(row) {
      this.name2 = row.name
      this.gameFilter = ''
      this.kaiguan = false
      this.search3()
    }, value_format(row, column, value) {
      // 截取当前数据到小数点后两位
      if (value == 0 || isNaN(value)) {

        return "-"
      } else {
        value = Math.round(value)
        value += ''
        if (!value.includes('.')) value += '.'
        return value.replace(/(\d)(?=(\d{3})+\.)/g, function ($0, $1) {
          return $1 + ','
        }).replace(/\.$/, '')
      }
    },
    async search3() {
      if (!Array.isArray(this.value2) || this.value2.length !== 2) {
        this.$message.warning('请选择查询日期')
        return
      }
      this.loading2 = true
      this.searchAble = false
      try {
        const params = {
          stats: this.stats,
          start: this.value2[0],
          end: this.value2[1] + 86400000 - 1
        }
        if (this.name2) {
          params.id = this.name2
        } else if (this.accountNames.length) {
          params.accounts = this.accountNames.join(',')
        }
        if (this.gameFilter) {
          params.game = this.gameFilter
        }
        const response = await this.$axios.get('/data/zhibo/findAllData', {params})
        if (!response.data || !response.data.success) {
          throw new Error((response.data && response.data.msg) || '订单查询失败')
        }
        this.allOrderRows = this.normalizeOrderRows(response.data.data)
        this.applyOrderGameFilter()
        this.kaiguan = false
        this.$message.success('查询完成，共 ' + this.tableData2.length + ' 条订单')
        this.doTableLayout()
      } catch (error) {
        this.tableData2 = []
        this.allOrderRows = []
        this.$message.error(error.message || '订单查询失败')
      } finally {
        this.loading2 = false
        this.searchAble = true
      }
    }


  },


}
</script>

<style>
.zhibo-cookie-page {
  min-height: 100vh;
  background-color: #eef3f8;
  box-sizing: border-box;
  overflow: auto;
  padding: 16px 20px 24px;
}

.zhibo-cookie-page .repair_header {
  width: 100%;
  min-height: 64px;
  background-color: #fff;
  border: 1px solid #edf0f5;
  border-radius: 6px;
  box-shadow: 0 5px 15px -5px rgba(0, 0, 0, 0.13);
  box-sizing: border-box;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  padding: 12px 16px;
  transition: box-shadow .2s ease;
}

.zhibo-cookie-page .header-title {
  flex: 0 0 auto;
  min-width: 132px;
  padding-right: 4px;
}

.zhibo-cookie-page .page-title {
  color: #1f2d3d;
  font-size: 17px;
  font-weight: 700;
  line-height: 22px;
}

.zhibo-cookie-page .page-meta {
  margin-top: 3px;
  color: #8a94a6;
  font-size: 12px;
}

.zhibo-cookie-page .repair_header:hover,
.zhibo-cookie-page .table-card:hover {
  box-shadow: 0 8px 22px -10px rgba(31, 45, 61, 0.42);
}

.zhibo-cookie-page .toolbar-main {
  flex: 1;
  min-width: 0;
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 10px;
}

.zhibo-cookie-page .toolbar-button {
  margin-top: 0;
}

.zhibo-cookie-page .field-setting-button {
  font-size: 13px;
  font-family: "Microsoft YaHei", Arial, sans-serif;
  font-weight: 600;
  color: #1f1f1f;
}

.zhibo-cookie-page .account-select {
  width: 190px;
}

.zhibo-cookie-page .status-select {
  width: 120px;
}

.zhibo-cookie-page .game-select {
  width: 150px;
}

.zhibo-cookie-page .control-label {
  color: #606266;
  font-size: 13px;
  white-space: nowrap;
}

.zhibo-cookie-page .view-switch {
  flex: 0 0 auto;
}

.zhibo-cookie-page .date-range-picker {
  width: 330px;
}

.zhibo-cookie-page .switch-wrap {
  height: 28px;
  display: inline-flex;
  align-items: center;
  gap: 8px;
  white-space: nowrap;
  color: #515a6e;
  font-size: 13px;
  background-color: #f7f9fc;
  border: 1px solid #ecf0f6;
  border-radius: 4px;
  padding: 0 8px;
}

.zhibo-cookie-page .export-action {
  flex: 0 0 auto;
  display: flex;
  justify-content: flex-end;
}

.zhibo-cookie-page .summary-grid {
  display: grid;
  grid-template-columns: repeat(4, minmax(150px, 1fr));
  gap: 12px;
  margin-top: 14px;
}

.zhibo-cookie-page .order-summary-grid {
  grid-template-columns: repeat(6, minmax(138px, 1fr));
}

.zhibo-cookie-page .summary-card {
  min-height: 74px;
  background: #fff;
  border: 1px solid #e6ebf2;
  border-left: 4px solid #8a94a6;
  border-radius: 6px;
  box-sizing: border-box;
  padding: 12px 14px;
  display: flex;
  flex-direction: column;
  justify-content: center;
}

.zhibo-cookie-page .summary-label {
  color: #7d8796;
  font-size: 12px;
  line-height: 18px;
}

.zhibo-cookie-page .summary-card strong {
  margin-top: 4px;
  color: #1f2d3d;
  font-size: 22px;
  line-height: 28px;
  font-weight: 700;
}

.zhibo-cookie-page .summary-account {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.zhibo-cookie-page .summary-primary {
  border-left-color: #2f80ed;
}

.zhibo-cookie-page .summary-info {
  border-left-color: #0f8b8d;
}

.zhibo-cookie-page .summary-success {
  border-left-color: #27ae60;
}

.zhibo-cookie-page .summary-warning {
  border-left-color: #f2994a;
}

.zhibo-cookie-page .summary-danger {
  border-left-color: #d94e4e;
}

.zhibo-cookie-page .summary-muted {
  border-left-color: #8a94a6;
}

.zhibo-cookie-page .summary-purple {
  border-left-color: #7c5cc4;
}

.zhibo-cookie-page .summary-progress .el-progress {
  margin-top: 8px;
}

.zhibo-cookie-page .summary-progress .el-progress-bar__outer {
  background-color: #eef2f7;
}

.zhibo-cookie-page .el-table__footer-wrapper td {
  background: #f3f6fa;
  color: #303133;
  font-weight: 600;
}

.zhibo-cookie-page .repairOrder_div {
  width: 100%;
  margin-top: 16px;
  border-radius: 6px;
}

.zhibo-cookie-page .table-card {
  background-color: #fff;
  border: 1px solid #edf0f5;
  border-radius: 6px;
  box-shadow: 0 5px 15px -5px rgba(0, 0, 0, 0.13);
  box-sizing: border-box;
  overflow: hidden;
  padding: 14px;
  transition: box-shadow .2s ease;
}

.zhibo-cookie-page .table-card-head {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  margin-bottom: 12px;
}

.zhibo-cookie-page .card-title {
  color: #1f2d3d;
  font-size: 15px;
  font-weight: 700;
  line-height: 22px;
}

.zhibo-cookie-page .card-meta {
  margin-top: 2px;
  color: #8a94a6;
  font-size: 12px;
}

.zhibo-cookie-page .table-1 {
  width: 100%;
}

.zhibo-cookie-page .el-table th {
  font-weight: 600;
}

.zhibo-cookie-page .el-table .cell {
  line-height: 20px;
}

.zhibo-cookie-page .el-table .is-current-cookie > td {
  background-color: #fff7e8 !important;
}

.zhibo-cookie-page .el-table .is-online-cookie > td {
  background-color: #f8fffb;
}

.zhibo-cookie-page .el-table__footer-wrapper td {
  background-color: #f7f9fc;
  color: #1f2d3d;
  font-weight: 600;
}

.zhibo-cookie-page .cookie-preview {
  color: #596273;
  font-family: Consolas, Monaco, "Microsoft YaHei", monospace;
  font-size: 12px;
}

.zhibo-cookie-page .table-action {
  padding: 0;
  color: #2f80ed;
  font-weight: 600;
}

.zhibo-cookie-page .table-action:hover {
  color: #1c5fb8;
}

.zhibo-cookie-page .cover-image {
  width: 56px;
  height: 56px;
  border-radius: 4px;
  object-fit: cover;
  vertical-align: middle;
}

.zhibo-cookie-dialog .el-dialog__title {
  font-weight: 700 !important;
  color: #515a6e !important;
}

.zhibo-cookie-dialog .el-dialog__body {
  padding: 18px 24px 4px;
}

.zhibo-cookie-dialog .el-dialog__footer {
  padding: 12px 24px 20px;
}

.zhibo-cookie-dialog .cookie-form .el-select,
.zhibo-cookie-dialog .cookie-form .el-input,
.zhibo-cookie-dialog .cookie-form .el-textarea {
  width: 100%;
}

.zhibo-cookie-dialog .el-textarea__inner {
  font-family: "Microsoft YaHei", Arial, sans-serif;
  font-size: 14px;
}

@media (max-width: 1200px) {
  .zhibo-cookie-page {
    padding: 12px;
  }

  .zhibo-cookie-page .repair_header {
    align-items: flex-start;
  }

  .zhibo-cookie-page .summary-grid,
  .zhibo-cookie-page .order-summary-grid {
    grid-template-columns: repeat(3, minmax(150px, 1fr));
  }

  .zhibo-cookie-page .export-action {
    padding-top: 1px;
  }
}

@media (max-width: 768px) {
  .zhibo-cookie-page .repair_header {
    display: block;
  }

  .zhibo-cookie-page .header-title {
    margin-bottom: 10px;
  }

  .zhibo-cookie-page .toolbar-main {
    display: grid;
    grid-template-columns: 1fr;
    gap: 8px;
  }

  .zhibo-cookie-page .account-select,
  .zhibo-cookie-page .status-select,
  .zhibo-cookie-page .game-select,
  .zhibo-cookie-page .date-range-picker,
  .zhibo-cookie-page .toolbar-main .el-button,
  .zhibo-cookie-page .switch-wrap {
    width: 100%;
  }

  .zhibo-cookie-page .switch-wrap {
    justify-content: space-between;
  }

  .zhibo-cookie-page .export-action {
    margin-top: 10px;
    justify-content: stretch;
  }

  .zhibo-cookie-page .export-action .el-button {
    width: 100%;
  }

  .zhibo-cookie-page .table-card {
    padding: 10px;
  }

  .zhibo-cookie-page .summary-grid,
  .zhibo-cookie-page .order-summary-grid {
    grid-template-columns: 1fr;
  }

  .zhibo-cookie-page .table-card-head {
    align-items: flex-start;
    flex-direction: column;
  }

  .zhibo-cookie-dialog {
    width: 92vw !important;
  }
}

</style>
